<template>
	<v-tooltip
		:text="`${showNova ? 'Nova' : 'Role' + message.sender.toString()} • ${new Date(
			message.created,
		).toLocaleTimeString()}`"
		location="top start"
	>
		<template v-slot:activator="{ props }">
			<span v-bind="props" class="author-element" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
				<div v-if="showPlayButton">
					<PlayButton :message="message" :played="played" @play="played = true" />
				</div>
				<div v-else>
					<div
						v-if="message.progress.stt == 'processing'"
						style="background: #4fc3f7; border-radius: 50%; height: 40px; width: 40px"
					>
						<NtaAudioIndicator
							color="#000000"
							width="30px"
							height="30px"
							style="margin-top: 4px; margin-left: 5px"
						/>
					</div>
					<Avatar
						v-else
						:image="showNova ? '/Nova-Small.png' : undefined"
						:icon="showBot ? 'mdi-robot' : undefined"
						:color="showNova ? '#4db6ac' : undefined"
						:text="showNova ? undefined : showBot ? undefined : `${message.sender.toString()}`"
						:nova-img="true"
					/>
				</div>
			</span>
		</template>
	</v-tooltip>
</template>

<script setup lang="ts">
import type { AlternisMessage } from "../../../../store/alternis_new";
import { useAlternisNewStore } from "../../../../store/alternis_new";
import { NtaAudioIndicator } from "@lr-notitia/notitia-ui/components";
import Avatar from "./Avatar.vue";
import PlayButton from "./PlayButton.vue";
import { ref, computed } from "vue";

const compProps = defineProps<{
	message: AlternisMessage;
	showNova?: boolean;
	showBot?: boolean;
}>();

const alternisNewStore = useAlternisNewStore();

const isHovered = ref(false);
const showPlayButton = computed(
	() =>
		compProps.message.sender == 0 &&
		!alternisNewStore.isVoicebot &&
		!alternisNewStore.isInactive &&
		compProps.message.progress.stt == "completed" &&
		Object.keys(compProps.message["translations"]).length > 0,
);
const played = ref(false);
</script>
